import React, { useState } from "react";
import { Modal, Input } from "antd";
import useCreate from "hooks/useCreate";

import CustomComponents from "../CustomComments";

const AddCommentModal = ({ handleClose, refetch, issue_id }) => {
  const [content, setContent] = useState("");

  const { is_saving, create } = useCreate({
    path: "/issue_comments",
    onSuccess: refetch,
    success_message: 'Dodano komentarz do zgłoszenia'
  });

  const handleOk = async () => {
    try {
      await create({
        issue_id,
        content,
      });
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      style={{ top: 45 }}
      maskClosable={false}
      width={700}
      title="Dodaj komentarz"
      open={true}
      onOk={handleOk}
      onCancel={handleClose}
      cancelText="Anuluj"
      okText="Dodaj"
      okButtonProps={{
        disabled: !content || is_saving,
        loading: is_saving,
      }}
    >
      <Input.TextArea
        value={content}
        style={{ marginBottom: 20 }}
        onChange={({ target: { value } }) => setContent(value)}
        rows={7}
        maxLength={400}
        showCount={true}
      />
      <CustomComponents content={content} setContent={setContent} />
    </Modal>
  );
};

export default AddCommentModal;
